/** @jsx jsx */
import { jsx } from '@emotion/react';

import { useContext, useState } from 'react';

import useRouter from 'js/lib/useRouter';

import { InlineNotification } from '@coursera/cds-core';

import { ProfileContext } from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileContextProvider';
import ShareProfileLinkDialog from 'bundles/account-profile/components/recruiting-profile-viewer/components/profile-and-invitation/ShareProfileLinkDialog';
import { DeepLinkParams } from 'bundles/account-profile/components/types';
import ErrorBoundaryWithTagging from 'bundles/common/components/ErrorBoundaryWithTagging';

import _t from 'i18n!nls/account-profile';

const PrivacySettingsSection = () => {
  const { editable } = useContext(ProfileContext);
  const router = useRouter();
  const {
    location: { query, pathname },
  } = router;
  const { deepLink } = query;

  const [showPrivacySettingsDialog, setShowPrivacySettingsDialog] = useState<boolean>(
    deepLink === DeepLinkParams.PRIVACY_SETTINGS
  );
  const handleCloseDialog = () => {
    if (deepLink) {
      router.replace({ pathname, query: { deepLink: undefined } });
    }
    setShowPrivacySettingsDialog(false);
  };

  if (!editable) return null;

  return (
    <div>
      {showPrivacySettingsDialog && (
        <ShareProfileLinkDialog
          isOpen={showPrivacySettingsDialog}
          onClose={handleCloseDialog}
          openPrivacySettingsDialog={true}
        />
      )}
    </div>
  );
};

const ErrorBoundPrivacySettingsSection = () => (
  <ErrorBoundaryWithTagging
    componentName="PrivacySettingsSection"
    errorComponent={
      <InlineNotification severity="error" title={_t('There has been an error')} role="alert">
        {_t(
          'There has been an error in the privacy settings section of the page. Our development team will be alerted.'
        )}
      </InlineNotification>
    }
  >
    <PrivacySettingsSection />
  </ErrorBoundaryWithTagging>
);

export default ErrorBoundPrivacySettingsSection;
